
import medtrustBg from "../../admin/assets/medtrust.jpg";
import React, { useState, useEffect } from 'react';
import Header from '../../Compoents/Header';
import {
  FaPhoneAlt,
  FaHeartbeat,
  FaEye,

  FaBaby,
  FaBrain,

} from "react-icons/fa";
import {
  FaLungs,

  FaWheelchair,
  FaRibbon,

} from "react-icons/fa";
import {

  GiKneeCap,

} from "react-icons/gi";
import {

  MdLocalHospital,

} from "react-icons/md";

import {
  GiStomach,
  GiKidneys,

  GiMedicines,
} from "react-icons/gi";

import { motion } from "framer-motion";
import Footer from "../../Compoents/Footer";
import MedtrustHeader from "../../Compoents/MedtrustHeader";
import MedtrustFooter from "../../Compoents/MedtrustFooter";
import HeroSlider from "./components/TreatmentSlide";

const Treatment = () => {
  const [activeItem, setActiveItem] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);


  useEffect(() => {
    setIsVisible(true);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    },
  };

  const toptreatment = [
    {
      title: "Cardiology",
      image: "assets/imgs/treatment/cardiology image.png",
    },
    {
      title: "Respiratory",
      image: "assets/imgs/treatment/Respiratory image.png",
    },

    {
      title: "Gastroenterology",
      image: "assets/imgs/treatment/Gastroenterology image.png",
    },
    {
      title: "Kidney & Urology",
      image: "assets/imgs/treatment/Kidney & Urology image.png",
    },
    {
      title: "Stroke & Paralysis",
      image: "assets/imgs/treatment/Stroke & Paralysis image.png",
    },

    {
      title: "TCM",
      image: "assets/imgs/treatment/TCM image.png",
    },
    {
      title: "Rehabilitation",
      image: "assets/imgs/treatment/Rehabilitation image.png",
    },
    {
      title: "Cancer",
      image: "assets/imgs/treatment/Cancer image.png",
    },
    {
      title: "Brain & Spine Surgery",
      image: "assets/imgs/treatment/Brain & Spine Surgery image.png",
    },

    {
      title: "Hip & Joint Replacement",
      image: "assets/imgs/treatment/Hip & Joint Replacement image.png",
    },

    {
      title: "Arthritis & Joint Pain Management",
      image: "assets/imgs/treatment/Arthritis & Joint Pain Management image.png",
    },


    {
      title: "IVF",
      image: "assets/imgs/treatment/IVF image.png",
    },

  ];


  const treat = [
    {
      title: "Cardiology",
      image: "assets/imgs/treatment/cardiology image.png",
    },
    {
      title: "Respiratory",
      image: "assets/imgs/treatment/Respiratory image.png",
    },
    {
      title: "Endocrine",
      image: "assets/imgs/treatment/Endocrine image.png",
    },
    {
      title: "Gastroenterology",
      image: "assets/imgs/treatment/Gastroenterology image.png",
    },
    {
      title: "Kidney & Urology",
      image: "assets/imgs/treatment/Kidney & Urology image.png",
    },
    {
      title: "Stroke & Paralysis",
      image: "assets/imgs/treatment/Stroke & Paralysis image.png",
    },
    {
      title: "Eye Surgery",
      image: "assets/imgs/treatment/Eye Surgery image.png",
    },
    {
      title: "Ear Surgery",
      image: "assets/imgs/treatment/Ear Surgery image.png",
    },
    {
      title: "TCM",
      image: "assets/imgs/treatment/TCM image.png",
    },
    {
      title: "Rehabilitation",
      image: "assets/imgs/treatment/Rehabilitation image.png",
    },
    {
      title: "Cancer",
      image: "assets/imgs/treatment/Cancer image.png",
    },
    {
      title: "Brain & Spine Surgery",
      image: "assets/imgs/treatment/Brain & Spine Surgery image.png",
    },
    {
      title: "Breast Surgery",
      image: "assets/imgs/treatment/Breast Surgery image.png",
    },
    {
      title: "Hip & Joint Replacement",
      image: "assets/imgs/treatment/Hip & Joint Replacement image.png",
    },
    {
      title: "General Surgery",
      image: "assets/imgs/treatment/General Surgery image.png",
    },
    {
      title: "Pediatric Surgery",
      image: "assets/imgs/treatment/Pediatric Surgery image.png",
    },
    {
      title: "Plastic surgery",
      image: "assets/imgs/treatment/Plastic Surgery image.png",
    },
    {
      title: "Arthritis & Joint Pain Management",
      image: "assets/imgs/treatment/Arthritis & Joint Pain Management image.png",
    },
    {
      title: "Antiaging Treatment",
      image: "assets/imgs/treatment/Antiaging Treatment image.png",
    },
    {
      title: "Steam Cell Therapy",
      image: "assets/imgs/treatment/Stem Cell Therapy image.png",
    },
    {
      title: "Sports medicine",
      image: "assets/imgs/treatment/Sports Medicine image.png",
    },
    {
      title: "Oral care",
      image: "assets/imgs/treatment/Oral care image.png",
    },
    {
      title: "Target organ checks up",
      image: "assets/imgs/treatment/Target organ checks up image.png",
    },
    {
      title: "Diabetics Management",
      image: "assets/imgs/treatment/Diabetics Management image.png",
    },

    {
      title: "Obesity Management",
      image: "assets/imgs/treatment/Obesity Management image.png",
    },
    {
      title: "Gynecological Treatment",
      image: "assets/imgs/treatment/Gynecological Treatment image.png",
    },
    {
      title: "IVF",
      image: "assets/imgs/treatment/IVF image.png",
    },
    {
      title: "Specialized Health Check-up",
      image: "assets/imgs/treatment/Specialized Health Check-up image.png",
    },
  ];




  const treatments = [
    { icon: <FaHeartbeat size={40} />, label: "Cardiology" },
    { icon: <FaLungs size={40} />, label: "Respiratory" },
    { icon: <FaBaby size={40} />, label: "Endocrine" },
    { icon: <GiStomach size={40} />, label: "Gastroenterology" },         // Stomach
    { icon: <GiKidneys size={40} />, label: "Kidney & Urology" },         // Kidneys
    { icon: <GiKneeCap size={40} />, label: "Stroke & Paralysis" },       // Bone/Joint paralysis (best fit)
    { icon: <FaEye size={40} />, label: "Eye Surgery" },                  // Eye
    { icon: <MdLocalHospital size={40} />, label: "Ear Surgery" },        // Generic surgical icon
    { icon: <GiMedicines size={40} />, label: "TCM" },                    // Traditional medicine bowl
    { icon: <FaWheelchair size={40} />, label: "Rehabilitation" },        // Rehab
    { icon: <FaRibbon size={40} />, label: "Cancer" },                    // Cancer Awareness
    { icon: <FaBrain size={40} />, label: "Brain & Spine Surgery" },      // Brain
  ];



  const NavItem = ({ icon, label, index, isMenuOpen }) => (
    <div
      className={`group relative flex items-center gap-4 p-4 rounded-r-2xl cursor-pointer
                transition-all duration-500 ease-out hover:bg-white/20 hover:pr-8
                ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}
                ${activeItem === index ? 'bg-white/25 pr-8 scale-100' : 'bg-white/10'}`}
      style={{
        transitionDelay: isMenuOpen ? `${index * 80}ms` : '0ms',
        backdropFilter: 'blur(10px)',
      }}
      onMouseEnter={() => setActiveItem(index)}
      onMouseLeave={() => setActiveItem(null)}
    >
      {/* Icon with animation */}
      <div className="text-4xl transform transition-transform duration-300 
                    group-hover:scale-110 group-hover:rotate-12">
        {icon}
      </div>

      {/* Label - Hidden on small screens */}
      <span className="hidden md:block text-lg font-medium text-white whitespace-nowrap
                     transition-all duration-300 group-hover:text-yellow-300">
        {label}
      </span>

      {/* Hover indicator */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-0 
                    bg-gradient-to-b from-yellow-400 to-red-500 rounded-l-full
                    transition-all duration-300 group-hover:h-3/4" />

      {/* Shine effect on hover */}
      <div className="absolute inset-0 rounded-r-2xl opacity-0 
                    group-hover:opacity-100 transition-opacity duration-500
                    bg-gradient-to-r from-transparent via-white/10 to-transparent
                    -translate-x-full group-hover:translate-x-full pointer-events-none"
        style={{ transition: 'transform 0.8s ease-out, opacity 0.3s' }} />
    </div>
  );



  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-600">
      <MedtrustHeader />

      {/* Main Section */}
      {/* <section className="relative h-screen flex items-center justify-start bg-cover bg-center bg-no-repeat"> */}
    
      {/* <section
        id="home"
        className="relative h-[85vh] flex items-center justify-start bg-cover bg-center bg-no-repeat text-white"
        style={{
          backgroundImage: 'url("assets/imgs/banner/banner img.png")', //`url(${medtrustBg})`,
        }}
      >
        
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-blue-500/40 to-transparent" />

       
        <div className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 20px 20px, rgba(255,255,255,0.05) 1px, transparent 0)`,
             backgroundSize: '40px 40px'
          }} />

        

        
        <div className="relative z-10 flex-1 flex items-center justify-center px-12">
          <div className={`text-center transition-all duration-1000 delay-500
                                   ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h1 className="text-6xl font-bold text-white mb-4 drop-shadow-2xl">
              Best Treatments Options by SQUARE MEDTRUST
            </h1>
            <p className="text-2xl text-white/90 mb-8 drop-shadow-lg">
              Review and Choose Best Treatment Options Globally
            </p>


            




          </div>




        </div>
        

        
        <div className="absolute bottom-10 left-10 w-20 h-20 border-4 border-yellow-400/30 
                              rounded-full animate-pulse" />
        <div className="absolute top-20 right-20 w-32 h-32 border-4 border-red-400/20 
                              rounded-full animate-pulse delay-150" />


       
        <motion.div
          className="absolute bottom-6 left-5 grid grid-cols-6 gap-4 col-span-6"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {treatments.map((item, index) => (
            <motion.div key={index} variants={itemVariants}>
              <NavItem
                icon={item.icon}
                label={item.label}
                index={index}
              />
            </motion.div>
          ))}
        </motion.div>
      </section> */}

      <HeroSlider />




      {/* Top treatment */}
      <section className="bg-white px-5 py-4">
        <div className="px-8 py-10">
          <h2 className="text-5xl font-bold mb-8">Top Treatments</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {toptreatment.map((item, index) => (
              <motion.div
                key={index}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }} // triggers when 20% visible
                className="relative overflow-hidden rounded-2xl shadow-md group cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-56 object-cover transform transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all duration-300"></div>
                <h3 className="absolute inset-0 flex items-center justify-center text-white text-3xl font-semibold text-center px-3">
                  {item.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </div>


      </section>

      {/* All exclusive */}
      <section className="bg-white px-5 py-4">
        <div className="px-8 py-10">
          <h2 className="text-5xl font-bold mb-8">All Inclusive Treatments</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {treat.map((item, index) => (
              <motion.div
                key={index}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }} // triggers when 20% visible
                className="relative overflow-hidden rounded-2xl shadow-md group cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-56 object-cover transform transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all duration-300"></div>
                <h3 className="absolute inset-0 flex items-center justify-center text-white text-3xl font-semibold text-center px-3">
                  {item.title}
                </h3>
              </motion.div>
            ))}
          </div>
        </div>


      </section>
      {/* <ContactUs /> */}
      <ContactCard />

      <MedtrustFooter />

    </div>


  );
};

export default Treatment;


const ContactUs = () => {
  return (
    <section>
      <div className="bg-white p-8">
       <div className="border border-blue-500 rounded-2xl p-8 max-w-3xl mx-auto mb-12">

        <h2 className="text-3xl md:text-4xl text-blue-950 text-center mt-4"> Are You Ready To Contact With Us</h2>
        <div className="flex flex-row items-center justify-center mt-4 gap-3">
          <FaPhoneAlt className="text-blue-600 text-2xl" />

          <h1 className="text-center text-2xl font-medium text-blue-500">
            (+86) 19811976744
          </h1>
        </div>

        <div className="w-full flex justify-center  my-8">
          <a
            href="tel:+8619811976744"
            className="inline-flex items-center gap-2 bg-blue-900 text-white px-7 py-4 rounded-full text-lg font-semibold shadow hover:bg-blue-700 transition"
          >
            Contact Us +
          </a>
        </div>

        </div>


      </div>

    </section>
  )
}




const ContactCard = () => {
  return (
    <section className="w-full bg-gradient-to-b from-gray-50 to-white py-24 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20">

        {/* LEFT SECTION */}
        <div className="relative flex justify-center">
          {/* Background Blobs */}
          <div className="absolute -top-12 -left-12 w-48 h-48 bg-orange-100 rounded-full blur-2xl"></div>
          <div className="absolute -bottom-20 -right-10 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-60"></div>

          {/* Image Card */}
          <div className="relative rounded-3xl overflow-hidden border border-gray-200 bg-white">
            <img
              src="assets/imgs/appointment/appointment.png"
              alt="Hospital"
              className="w-full h-[450px] object-cover"
            />

            {/* Floating Glass Card */}
            <div className="absolute bottom-6 left-6 bg-white/70 backdrop-blur-lg p-6 rounded-2xl shadow-xl border border-white/40">
              <h3 className="text-xl font-semibold text-gray-900">
                We are here to help
              </h3>
              <p className="text-gray-600 text-sm mt-2">
                Our team responds within 24 hours.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="flex flex-col justify-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-8">
            Are You Ready To Contact With Us
          </h2>

          <p className="text-gray-600 text-lg leading-relaxed mb-10">
            Reach out to us with any inquiries or support needs.  
            We are committed to offering the best possible assistance.
          </p>

          {/* Phone Row */}
          <div className="flex flex-row items-center gap-3 mb-6">
            <FaPhoneAlt className="text-blue-700 text-3xl" />
            <h1 className="text-2xl font-semibold text-blue-700">
              (+86) 198 1197 6744
            </h1>
          </div>

          {/* Call Button */}
          <div>
            <a
              href="tel:+8619811976744"
              className="inline-flex items-center gap-2 bg-blue-900 text-white px-8 py-4 rounded-full text-lg font-semibold shadow hover:bg-blue-700 transition"
            >
              Contact Us +
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};








